// src/pages/HomePage.js
import React from 'react';
import { Link } from 'react-router-dom';
import cctvData from '../data/cctvData';

const HomePage = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>📹 CCTV Streams</h1>
      <ul>
        {cctvData.map(cam => (
          <li key={cam._id}>
            <Link to={`/${cam.gps.replace(/,\s*/g, ',')}`}>{cam.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HomePage;
